import { useEffect } from 'react';

export function usePreloadMedia(path) {
    useEffect(() => {
        async function preload() {
            await fetch(path);
        }

        preload();

        return () => {

        };
    }, [path]);
}
